
import Vue from 'vue'
import FooterSubMenu from '../footer-sub-menu/index.vue'

export default Vue.extend({
  components: {
    FooterSubMenu
  },
  props: {
    rootLink: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showMenu: false
    }
  }
})
